// extracted by mini-css-extract-plugin
module.exports = {"root":"Period__root___1XsNa","label":"Period__label___iW6RF","black":"Period__black___1URE4","separator":"Period__separator___MG-9A"};